const filterByText = (searchText, coins) => {
  // Use the filter method to create a new array that includes only the coins that match the search criteria
  let filteredByText = coins.filter((elem) => {
      // Check if the lowercase name or symbol of the coin includes the lowercase searchText
      if (elem.name.toLowerCase().includes(searchText.toLowerCase()) || elem.symbol.toLowerCase().includes(searchText.toLowerCase())) {
          return true; // Include the coin in the filtered array
      }
      return false; // Exclude the coin from the filtered array
  });

  // Return the filtered array
  return filteredByText;
};

export default filterByText;
